import { render, staticRenderFns } from "./GSelect.vue?vue&type=template&id=7ecd7fd4&scoped=true"
import script from "./GSelect.vue?vue&type=script&lang=js"
export * from "./GSelect.vue?vue&type=script&lang=js"
import style0 from "./GSelect.vue?vue&type=style&index=0&id=7ecd7fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd7fd4",
  null
  
)

export default component.exports